import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Button } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import { getRoute } from '@common/constants/CampusRoutes';

import imageSrc from '@common/assets/images/error-page-image.webp';

import useOutdatedError from './hooks/useOutdatedError';
import {
	StyledErrorPageImage,
	StyledErrorPageImageWrap,
	StyledErrorPageTitle,
	StyledErrorPageWrap,
} from './styled';

type PropsType = {
	resetError: () => void;
	error?: any;
};

function ErrorPage({ resetError, error }: PropsType) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const isInitialMount = useRef(true);

	useOutdatedError(error);

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
		} else {
			resetError();
		}
	}, [pathname]);

	const handleNavigate = () => {
		navigate(getRoute(['NEWS']));
	};

	return (
		<StyledErrorPageWrap>
			<StyledErrorPageImageWrap>
				<StyledErrorPageImage src={imageSrc} alt="Robot error" />
			</StyledErrorPageImageWrap>
			<Box>
				<StyledErrorPageTitle>{t('shared.somethingWentWrong')}</StyledErrorPageTitle>
				<MediaTypography variant="body1" variants={{ sm: 'body2' }}>
					{t('errorPage.subTitle')}
				</MediaTypography>
			</Box>
			<Button variant="contained" onClick={handleNavigate}>
				{t('errorPage.goToNews')}
			</Button>
		</StyledErrorPageWrap>
	);
}

export default ErrorPage;
